<template>
  <form class="t-set-timezone" @submit.stop.prevent="Submit()">
    <h2>Заполните профиль</h2>
    <div class="t-inputBox">
      <div class="t-input "
           :class="{_error: item.error}"
           v-for="(item, index) in form"
           :key="index">
        <label>{{item.title}}</label>
        <v-select v-if="item.type === 'select'"
                  v-model="item.value"
                  :options="item.options"
                  :searchable="true"
                  :filterable="true"></v-select>
        <input v-if="item.type === 'text'" v-model="item.value">
      </div>
    </div>
    <p class="t-set-timezone__help">Рекомендуем заполнить профиль чтобы получить доверие у других пользователей.</p>
    <button class="t-btn"><span>Заполнить профиль</span></button>
  </form>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {mapActions} from 'vuex';
  import {store} from '../../store'

  export default {
    data() {
      return {
        form: [
          {
            type: 'text',
            name: 'last_name',
            title: 'Фамилия',
            value: '',
            placeholder: '',
            error: false,
            pattern: /^[а-яА-Яa-zA-Z-' ]{2,30}$/,
            required: false
          },
          {
            type: 'text',
            name: 'name',
            title: 'Имя',
            value: '',
            placeholder: '',
            error: false,
            pattern: /^[а-яА-Яa-zA-Z-' ]{2,30}$/,
            required: false
          },
          {
            type: 'select',
            name: 'time_zone',
            searchable: false,
            title: 'Укажите часовой пояс',
            value: '',
            options: store.getters['handbook/time_zone'],
            placeholder: '',
            error: false,
            pattern: '',
            required: false
          },
        ]
      }
    },
    computed: {
      ...mapGetters('staticText', ['signUp']),
      ...mapGetters('profile', ['user']),
    },
    methods: {
      ...mapActions('modal', ['modalDialogClose']),
      ...mapActions('msg', ['showMsg']),
      ...mapActions('coursesList', ['LoadStreams']),
      ...mapActions('profile', ['LoadUserInfo']),
      Submit() {
        let fd = new FormData();
        for (let i = 0; i < this.form.length; i++) {
          if (typeof this.form[i].value === 'object') {
            if (this.form[i].value !== null) {
              if (this.form[i].value.value) {
                fd.append(this.form[i].name, this.form[i].value.value);
              } else {
                if (this.form[i].name === 'birth_day') {
                  fd.append(this.form[i].name, JSON.stringify(this.form[i].value));
                } else {
                  fd.append(this.form[i].name, this.form[i].value);
                }
              }
            }
          } else {
            if (this.form[i].value !== '') {
              fd.append(this.form[i].name, this.form[i].value);
            }
          }
        }
        this.$http.put('update_info', fd)
          .then(response => response.json())
          .then(data => {
            if (data.success) {
              let fd = [];
              for (let i = 0; i < this.form.length; i++) {
                fd.push({
                  name: this.form[i].name,
                  value: this.form[i].value
                })
              }
              this.LoadUserInfo();
              this.modalDialogClose();
            } else {
              this.showMsg('Упс, что-то пошло не так, попробуйте позже')
            }
          })
          .catch(error => {
            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
          });
      },
    }
  }
</script>

<style lang="sass">
  .t-set-timezone
    width: 320px
    padding: 24px
    @extend %substrate
    &__help
      font-size: 13px
      text-align: justify
      margin-bottom: 10px
</style>



// WEBPACK FOOTER //
// src/vue_components/ModalDialog/Timezone.vue